export default __webpack_public_path__ + "static/media/favorites.bb8e21a9.svg";